import { useState } from "react";
import { useDispatch } from "react-redux";
import { Modal } from "antd";
import { buildBookingRef } from "../../utils/helpers";
import { cancel } from "../../store/actions/booking-actions";

export default function CancelBookingModal({ open, onClose, booking }) {
  const [isLoading, setIsLoading] = useState();
  const dispatch = useDispatch();

  const handleCancelBooking = () => {
    setIsLoading(true);
    dispatch(cancel(booking?.id));
    onClose();
    setIsLoading(false);
  };
  return (
    <Modal
      title={`Booking - ${booking?.id && buildBookingRef(booking.id)}`}
      open={open}
      onCancel={onClose}
      onOk={handleCancelBooking}
      okButtonProps={{ size: "large", style: { background: "#f00" } }}
      okText={"Yes"}
      cancelButtonProps={{ size: "large" }}
      width={450}
      loading={isLoading}
      styles={{
        body: { height: "80px", fontSize: "18px" },
      }}
      centered
    >
      <p>
        {"Are you sure you want to "}
        <span style={{ color: "#f00" }}>cancel</span>
        {` this booking?`}
      </p>
    </Modal>
  );
}
